<template>
  <div>
    <div v-if="loading" class="text-xs-center"></div>
    <div v-else-if="!data" class="text-xs-center">
      <v-icon x-large>highlight_off</v-icon>
      <div>Not found video</div>
    </div>
    <template v-else>
      <slot v-bind="{ url: url }"> </slot>
    </template>
  </div>
</template>

<script>
import config from '@/config'
export default {
  props: ['value', 'pageid'],
  data() {
    return {
      loading: true,
      data: null,
      binary: null,
      url: ''
    }
  },
  async mounted() {
    this.loading = true
    this.data = JSON.parse(this.value)

    try {
      this.url = `${config.serverUrl}linemessagecontenttypefile?pageid=${this.pageid}&messageid=${this.data.id}`
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/LineContentVideo.vue